import axios from 'axios';
import {
  FETCH_SHARED_WORKOUT_PROGRAM_DETAILS_START,
  FETCH_SHARED_WORKOUT_PROGRAM_DETAILS_FULFILLED,
  FETCH_SHARED_WORKOUT_PROGRAM_DETAILS_REJECTED,
  FETCH_SHARED_WORKOUT_PREVIEW_START,
  FETCH_SHARED_WORKOUT_PREVIEW_FULFILLED,
  FETCH_SHARED_WORKOUT_PREVIEW_REJECTED,
  SET_ACTIVE_SHARED_WORKOUT_MODAL,
  SET_IS_DOWNLOAD_BUTTON_CLICKED,
  DOWNLOAD_SHARED_WORKOUT_START,
  DOWNLOAD_SHARED_WORKOUT_FULFILLED,
  DOWNLOAD_SHARED_WORKOUT_REJECTED,
  DOWNLOAD_SHARED_WORKOUT_INITIALIZE_START,
  DOWNLOAD_SHARED_WORKOUT_INITIALIZE_FULFILLED,
  DOWNLOAD_SHARED_WORKOUT_INITIALIZE_REJECTED,
} from './actionTypes';

import { axiosUnauthed } from '../../../shared/utils/setCommonHeaders';
import { showErrorToast } from '../../../shared/utils/toastManager';

export const fetchProgram = (programSlug) => (
  (dispatch) => {
    dispatch({ type: FETCH_SHARED_WORKOUT_PROGRAM_DETAILS_START });
    axiosUnauthed.get(`/public/shared-workouts/${programSlug}`)
      .then((response) => {
        setTimeout(() => {
          dispatch({
            type: FETCH_SHARED_WORKOUT_PROGRAM_DETAILS_FULFILLED,
            payload: response.data,
          });
        }, 800);
      })
      .catch((err) => {
        setTimeout(() => {
          dispatch({
            type: FETCH_SHARED_WORKOUT_PROGRAM_DETAILS_REJECTED,
            payload: err,
          });
        }, 800);
      });
  }
);

export const fetchWorkout = (programSlug) => (
  (dispatch) => {
    dispatch({ type: FETCH_SHARED_WORKOUT_PREVIEW_START });
    axiosUnauthed.get(`/public/shared-workouts/${programSlug}/workout-preview`)
      .then((response) => {
        setTimeout(() => {
          dispatch({
            type: FETCH_SHARED_WORKOUT_PREVIEW_FULFILLED,
            payload: response.data,
          });
        }, 800);
      })
      .catch((err) => {
        dispatch({
          payload: err,
          type: FETCH_SHARED_WORKOUT_PREVIEW_REJECTED,
        });
      });
  }
);

export const downloadSharedWorkout = (obj) => (
  (dispatch) => {
    dispatch({ type: DOWNLOAD_SHARED_WORKOUT_START });
    axios.post('/assets/workout_transfer.php?act=save_info', obj, { crossDomain: true })
      .then((response) => {
        dispatch({
          payload: response.data,
          type: DOWNLOAD_SHARED_WORKOUT_FULFILLED,
        });
      })
      .catch((err) => {
        dispatch({
          payload: err,
          type: DOWNLOAD_SHARED_WORKOUT_REJECTED,
        });
      });
  }
);

// DOES NOT WORK
// Was trying to ping PHP but getting CORS errors. When we circle back to this hopefully the
// endpoint will be in node-server.
export const downloadSharedWorkoutInitialize = (submissionObj) => (
  (dispatch) => {
    dispatch({ type: DOWNLOAD_SHARED_WORKOUT_INITIALIZE_START });
    axios.post(
      `/assets/workout_transfer.php?act=initialize&exer_db=${submissionObj.exerDB}&save_id=${submissionObj.saveID}&new_save_id=&transfer_id=&shared_workout=${submissionObj.sharedWorkout}`,
      {
        crossDomain: true,
      },
    )
      .then((response) => {
        dispatch({
          payload: response.data,
          type: DOWNLOAD_SHARED_WORKOUT_INITIALIZE_FULFILLED,
        });
        const newObj = { ...submissionObj };
        newObj.transfer_id = response.data.transfer_id;
        dispatch(downloadSharedWorkout(newObj));
      })
      .catch((err) => {
        dispatch({
          payload: err,
          type: DOWNLOAD_SHARED_WORKOUT_INITIALIZE_REJECTED,
        });
        showErrorToast('An error occurred while initializing the download');
      });
  }
);

export const sharedWorkoutModal = (activeModal) => ({
  type: SET_ACTIVE_SHARED_WORKOUT_MODAL,
  payload: {
    activeModal,
  },
});

export const setDownloadButtonClicked = (bool) => ({
  type: SET_IS_DOWNLOAD_BUTTON_CLICKED,
  payload: {
    bool,
  },
});
